import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const $router = new Router({
    routes: [
        {
            path: '/',
            name: 'Home',
            component: resolve => require(['@/components/Home.vue'], resolve),
            meta: {
                breadCrumbsName: 'Home'
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: resolve => require(['@/components/Login.vue'], resolve)
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('@/components/Register')
        },
        {
            path: '/passwordBack',
            name: 'passwordBack',
            component: () => import('../components/passwordBack')
        },
        // 头部
        {
            path: '/header/stockHeader',
            name: 'Stockheader',
            component: resolve =>
                require(['@/components/header/stockHeader.vue'], resolve)
        },
        {
            path: '/header/personalHeader',
            name: 'PersonalHeader',
            component: resolve =>
                require(['@/components/header/personalHeader.vue'], resolve)
        },
        // 大陆企业
        {
            path: '/mainland/fuzzySearch',
            name: 'FuzzySearch',
            component: resolve =>
                require(['@/components/mainland/fuzzySearch.vue'], resolve),
            meta: {
                breadCrumbsName: 'FuzzySearch',
                isSpecialbread: true // 用于面包屑特别处理
            }
        },
        {
            path: '/mainland/commonHead',
            name: 'CommonHead',
            redirect: '/mainland/commonHead/baseInfo', // 路由重载至基本信息子路由
            component: resolve =>
                require(['@/components/mainland/commonHead.vue'], resolve),
            children: [
                {
                    path: 'baseInfo',
                    name: 'BaseInfo',
                    component: resolve =>
                        require(['@/components/mainland/baseInfo.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'StockDetail'
                    }
                },
                {
                    path: 'integratedRisk',
                    name: 'IntegratedRisk',
                    component: resolve =>
                        require(['@/components/mainland/integratedRisk.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'StockDetail'
                    }
                },
                {
                    path: 'knowledgeRights',
                    name: 'KnowledgeRights',
                    component: resolve =>
                        require(['@/components/mainland/knowledgeRights.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'StockDetail'
                    }
                },
                {
                    path: 'financialStatements',
                    name: 'FinancialStatements',
                    component: resolve =>
                        require(['@/components/mainland/financialStatements.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'StockDetail'
                    }
                },
                {
                    path: 'companyOpinion',
                    name: 'CompanyOpinion',
                    component: resolve =>
                        require(['@/components/mainland/companyOpinion.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'StockDetail'
                    }
                },
                {
                    path: 'opinionEvent',
                    name: 'opinionEvent',
                    meta: {
                        breadCrumbsName: 'StockDetail'
                    }
                },
                {
                    path: 'macroEvent',
                    name: 'macroEvent',
                    meta: {
                        breadCrumbsName: 'StockDetail'
                    }
                }
            ]
        },

        // 图谱
        // 企业关联人
        {
            path: '/map/busiAssociateInvest',
            name: 'BusiAssociateInvest',
            component: resolve =>
                require(['@/components/map/busiAssociateInvest.vue'], resolve),
            meta: {
                breadCrumbsName: 'PersonalDiagram'
            }
        },
        // 企业对外投资
        {
            path: '/map/busiInvestOut',
            name: 'BusiInvestOut',
            component: resolve =>
                require(['@/components/map/busiInvestOut.vue'], resolve),
            meta: {
                breadCrumbsName: 'CompanyInvestmentDiagram'
            }
        },
        // 自然人对外投资
        {
            path: '/map/naturalInvest',
            name: 'NaturalInvest',
            component: resolve =>
                require(['@/components/map/naturalInvest.vue'], resolve),
            meta: {
                breadCrumbsName: 'naturaPersonalDiagram'
            }
        },
        // 股权穿透部分
        {
            path: '/map/equity',
            name: 'EquityHead',
            redirect: '/map/equity/equityPenetration', // 路由重载至基本信息子路由
            component: resolve =>
                require(['@/components/map/equityHead.vue'], resolve),
            children: [
                {
                    path: 'equityPenetration',
                    name: 'EquityPenetration', // 股权穿透
                    component: resolve =>
                        require(['@/components/map/equityPenetration.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'EquityStructure'
                    }
                },
                {
                    path: 'suspectBeneficiary',
                    name: 'SuspectBeneficiary', // 疑似受益所有人
                    component: resolve =>
                        require(['@/components/map/suspectBeneficiary.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'EquityStructure'
                    }
                },
                {
                    path: 'highDanger',
                    name: 'HighDanger', // 高风险干系人
                    component: resolve =>
                        require(['@/components/map/highDanger.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'EquityStructure'
                    }
                }
            ]
        },
        // 控制路径
        {
            path: '/map/controlPath',
            name: 'ControlPath',
            component: resolve =>
                require(['@/components/map/controlPath.vue'], resolve),
            meta: {
                breadCrumbsName: 'ControlPath'
            }
        },
        // 二次穿透
        {
            path: '/map/secondaryTree',
            name: 'SecondaryTree',
            component: resolve =>
                require(['@/components/map/secondaryTree.vue'], resolve),
            meta: {
                breadCrumbsName: 'ShareholdingStructure'
            }
        },

        // 高级筛查
        {
            path: '/advanced/screening',
            name: 'AdvancedScreening',
            component: resolve =>
                require(['@/components/advanced/screening.vue'], resolve),
            meta: {
                keepAlive: true,
                breadCrumbsName: 'Advanced',
                isSpecialbread: true // 用于面包屑特别处理
            }
        },

        // 境外企业
        {
            path: '/abroad/fuzzySearch',
            name: 'AbroadFuzzySearch',
            component: resolve =>
                require(['@/components/abroad/fuzzySearch.vue'], resolve),
            meta: {
                breadCrumbsName: 'AbroadFuzzySearch',
                isSpecialbread: true // 用于面包屑特别处理
            }
        },
        {
            path: '/abroad/commonHead',
            name: 'AbroadCommonHead',
            redirect: '/abroad/commonHead/baseInfo', // 路由重载至基本信息子路由
            component: resolve =>
                require(['@/components/abroad/commonHead.vue'], resolve),
            children: [
                {
                    path: 'baseInfo',
                    name: 'AbroadBaseInfo',
                    component: resolve =>
                        require(['@/components/abroad/baseInfo.vue'], resolve),
                    meta: {
                        breadCrumbsName: 'AbroadStockDetail'
                    }
                }
            ]
        },

        // 黑名单
        {
            path: '/worldCheck/fuzzySearch',
            name: 'WCFuzzySearch',
            component: resolve =>
                require(['@/components/worldCheck/fuzzySearch.vue'], resolve),
            meta: {
                breadCrumbsName: 'WorldCheckFuzzySearch',
                isSpecialbread: true // 用于面包屑特别处理
            }
        },
        {
            path: '/worldCheck/fuzzySearchDQS',
            name: 'WCFuzzySearchDQS',
            component: resolve =>
                require(['@/components/worldCheck/fuzzySearchDQS.vue'], resolve),
            meta: {
                breadCrumbsName: 'WorldCheckFuzzySearch',
                isSpecialbread: true // 用于面包屑特别处理
            }
        },
        {
            path: '/worldCheck/basicInfo',
            name: 'WCBasicInfo',
            component: resolve =>
                require(['@/components/worldCheck/basicInfo.vue'], resolve),
            meta: {
                breadCrumbsName: 'WCBasicInfo'
            }
        },
        {
            path: '/worldCheck/basicInfoDQS',
            name: 'WCBasicInfoDQS',
            component: resolve =>
                require(['@/components/worldCheck/basicInfoDQS.vue'], resolve),
            meta: {
                breadCrumbsName: 'WCBasicInfo'
            }
        },
        {
            path: '/worldCheck/riskReason',
            name: 'WCRiskReason',
            component: resolve =>
                require(['@/components/worldCheck/riskReason.vue'], resolve),
            meta: {
                breadCrumbsName: 'RiskReason'
            }
        },
        {
            path: '/worldCheck/riskReasonDQS',
            name: 'riskReasonDQS',
            component: resolve =>
                require(['@/components/worldCheck/riskReasonDQS.vue'], resolve),
            meta: {
                breadCrumbsName: 'RiskReason'
            }
        },
        {
            path: '/worldCheck/assoInfo',
            name: 'WCAssoInfo',
            component: resolve =>
                require(['@/components/worldCheck/assoInfo.vue'], resolve),
            meta: {
                breadCrumbsName: 'worldcheckSocialNetworks'
            }
        },
        {
            path: '/worldCheck/assoInfoDQS',
            name: 'WCAssoInfoDQS',
            component: resolve =>
                require(['@/components/worldCheck/assoInfoDQS.vue'], resolve),
            meta: {
                breadCrumbsName: 'worldcheckSocialNetworks'
            }
        },
        {
            path: '/worldCheck/assoMap',
            name: 'WCAssoMap',
            component: resolve =>
                require(['@/components/worldCheck/assoMap.vue'], resolve),
            meta: {
                breadCrumbsName: 'WCSocialNetworkDiagram'
            }
        },
        {
            path: '/worldCheck/assoMapDQS',
            name: 'assoMapDQS',
            component: resolve =>
                require(['@/components/worldCheck/assoMapDQS.vue'], resolve),
            meta: {
                breadCrumbsName: 'WCSocialNetworkDiagram'
            }
        },

        // 个人中心
        {
            path: '/personalCenter',
            name: 'PersonalCenter',
            redirect: '/personalCenter/firmMonitorList', // 路由重载至基本信息子路由
            component: resolve =>
                require(['@/components/personalCenter/commonNav.vue'], resolve),
            children: [
                {
                    path: 'firmMonitorList',
                    name: 'FirmMonitorList',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/firmMonitorList.vue'
                        ], resolve)
                },
                {
                    path: 'firmMonitor',
                    name: 'FirmMonitor',
                    component: resolve =>
                        require(['@/components/personalCenter/firmMonitor.vue'], resolve)
                },
                {
                    path: 'personMonitorList',
                    name: 'PersonMonitorList',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/personMonitorList.vue'
                        ], resolve)
                },
                {
                    path: 'ReportManager',
                    name: 'ReportManager',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/ReportManager.vue'
                        ], resolve)
                },
                {
                    path: 'personMonitor',
                    name: 'PersonMonitor',
                    component: resolve =>
                        require(['@/components/personalCenter/personMonitor.vue'], resolve)
                },
                {
                    path: 'artificialCheck',
                    name: 'ArtificialCheck',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/artificialCheck.vue'
                        ], resolve)
                },
                {
                    path: 'artificialCheckDQS',
                    name: 'ArtificialCheckDQS',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/artificialCheckDQS.vue'
                        ], resolve),
                    children: [
                        {
                            path: 'artificialCheckDQSFirst',
                            name: 'ArtificialCheckDQSFirst',
                            component: resolve =>
                                require([
                                    '@/components/personalCenter/artificialCheckDQS/artificialCheckDQSFirst.vue'
                                ], resolve)
                        },
                        {
                            path: 'artificialCheckDQSSecond',
                            name: 'ArtificialCheckDQSSecond',
                            component: resolve =>
                                require([
                                    '@/components/personalCenter/artificialCheckDQS/artificialCheckDQSSecond.vue'
                                ], resolve)
                        }
                    ]
                },
                {
                    path: 'screeningRecordDQS',
                    name: 'ScreeningRecordDQS',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/screeningRecordDQS.vue'
                        ], resolve)
                },
                // 名单管理 12.27
                {
                    path: 'listManage',
                    name: 'ListManage',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/listManage.vue'
                        ], resolve)
                },
                {
                    path: 'financialReportList',
                    name: 'FinancialReportList',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/financialReportList.vue'
                        ], resolve)
                },
                {
                    path: 'financialReport',
                    name: 'FinancialReport',
                    component: resolve =>
                        require([
                            '@/components/personalCenter/financialReport.vue'
                        ], resolve)
                },
                {
                    path: 'opinionCollect',
                    name: 'OpinionCollect',
                    component: resolve =>
                        require(['@/components/personalCenter/opinionCollect.vue'], resolve)
                }
                // 企业数据批量处理
                // {
                //   path: "/dataBatchProcess/listCleaning",
                //   name: "listCleaning",
                //   component: () => import('@/components/personalCenter/dataBatchProcess/listCleaning.vue')
                // },
                // {
                //   path: "/dataBatchProcess/batchDownload",
                //   name: "batchDownload",
                //   component: () => import('@/components/personalCenter/dataBatchProcess/batchDownload.vue')
                // }
            ]
        },

        // *为方便客户仅访问财报，进行如下配置
        {
            path: '/mainland/financialStatements',
            name: 'UniqueFinancialStatements',
            component: resolve =>
                require(['@/components/mainland/financialStatements.vue'], resolve)
        },
        // *用于嵌入综合风险弹窗的舆情
        {
            path: '/mainland/companyOpinion',
            name: 'UniqueCompanyOpinion',
            component: resolve =>
                require(['@/components/mainland/companyOpinion.vue'], resolve)
        },
        // *综合风险
        {
            path: '/mainland/integratedRisk',
            name: 'UniqueIntegratedRisk',
            component: resolve =>
                require(['@/components/mainland/integratedRisk.vue'], resolve)
        }
    ]
})

$router.onError(error => {
    const pattern = /Loading chunk (\d)+ failed/g
    const isChunkLoadFailed = error.message.match(pattern)
    const targetPath = $router.history.pending.fullPath
    if (isChunkLoadFailed) {
        $router.replace(targetPath)
    }
})

$router.beforeEach((to, from, next) => {
    // 一旦从路由中获取到以下参数，立即存储至本地，后续页面直接通过session获取，且其他路由无需再传递
    var url_token = to.query && to.query.auth_token
    if (url_token && url_token !== undefined && url_token !== ' ') {
        sessionStorage.setItem('auth_token', url_token)
    } else {
        url_token = window.sessionStorage.getItem('auth_token')
    }

    var without_head = to.query && to.query.without_head
    if (without_head && without_head !== undefined && without_head !== ' ') {
        sessionStorage.setItem('without_head', without_head)
    }

    var without_finance = to.query && to.query.without_finance
    if (
        without_finance &&
        without_finance !== undefined &&
        without_finance !== ' '
    ) {
        sessionStorage.setItem('without_finance', without_finance)
    }

    var without_opinion = to.query && to.query.without_opinion
    if (
        without_opinion &&
        without_opinion !== undefined &&
        without_opinion !== ' '
    ) {
        sessionStorage.setItem('without_opinion', without_opinion)
    }

    // 未登录跳转到登录页面
    var csrf = localStorage.getItem('csrftoken')
    if (
        (!csrf || csrf === undefined || csrf === ' ' || csrf === 'undefined') &&
        (!url_token ||
            url_token === undefined ||
            url_token === ' ' ||
            url_token === 'undefined')
    ) {
        if (
            to.path === '/' ||
            to.path === '/login' ||
            to.path === '/register' ||
            to.path === '/passwordBack'
        ) {
            next()
        } else {
            sessionStorage.setItem('lasturl', JSON.stringify(to))
            next({path: '/login'})
        }
    } else {
        next()
    }
    // console.log(to)
})

$router.afterEach((to, from, next) => {
    // 友盟统计内容
    if (window._czc) {
        let contentUrl = '/#' + to.path
        let refererUrl = '/'
        window._czc.push(['_trackPageview', contentUrl, refererUrl])
    }
})

export default $router



// WEBPACK FOOTER //
// ./src/router/index.js